'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FileTwoTone = _interopRequireDefault(require('./lib/icons/FileTwoTone'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FileTwoTone;
exports.default = _default;
module.exports = _default;